import React, {useCallback, useState, useEffect} from 'react';
import InputWithMovingLabel from 'jd-library/InputWithMovingLabel';
import SliderHeader from 'jd-library/SliderHeader';
import SliderWrapper from 'jd-library/SliderWrapper';
import withRipple from 'jd-library/withRipple';
import historyHandler from 'jd-library/historyHandler';

import styles from './inputWithAutosuggestSliderStyle.scss';

import { getHighlightString } from "../../../../../utills";
import useInfiniteScroll from 'jd-library/useInfiniteScroll';

export default function InputWithAutosuggestSlider(props){ 

    const {
        sliderHeading = "", 
        suggestions = [],
        onSelect = () => {},
        showOutSideFields=false
    } = props; 

    const autoCompleteSuggestions = [...suggestions];
    const [inputValue, setInputValue] = useState(props?.input?.value || "");
    const [slider, toggleSlider] = useState(props.defaultOpen || false);
    const [filterSuggestions, setfilterSuggestions] = useState(
        autoCompleteSuggestions.length?
        autoCompleteSuggestions.filter((el,index) => index<25):autoCompleteSuggestions);
    const [sliderContRef,updateRef] = useState(null);
    const [isScrolled, setScroll] = useState(
		typeof document === 'object' && (document.scrollingElement.scrollTop > 0)
    );
    useEffect(() => {
        if(slider && suggestions?.length && props?.input?.value) {
            let inList = suggestions.find(e => typeof e.value === 'string' && e.value.toLowerCase() == props.input.value.toLowerCase());
            if(inList) {
                filterAutocompleteSuggestions(props.input.value);
            }
        }
    },[slider])
    const handleScroll = useCallback((e) => {
		setScroll(e.currentTarget.scrollTop> 5);
    }, []);
    /*  */

    useEffect(() => {
        if(suggestions?.length && suggestions[0]?.value != filterSuggestions[0]?.value){
            setfilterSuggestions(autoCompleteSuggestions.length?
                autoCompleteSuggestions.filter((el,index) => index<25):autoCompleteSuggestions)
        }
    },[suggestions])

    useEffect(() => {
        if(inputValue !== props?.input?.value) {
            setInputValue(props?.input?.value || '')
        }
    },[props?.input?.value])
    
    const autoSuggestionItemOnClick = (item) => {
        setTimeout(() => { 
            onSelect(item);
            setInputValue(item.value);
            historyHandler.closeCurrent();
        }, 300)
    }
    
    const [isFetching, setIsFetching] = useInfiniteScroll({
		scrollContainer: sliderContRef,
		loadMoreCB: () => {
            if(!inputValue) {
                setIsFetching(false);
                let suggestion = [...filterSuggestions];
                if(filterSuggestions.length < autoCompleteSuggestions.length){
                    let count = Number(filterSuggestions.length/25).toFixed(0);
                    suggestion = suggestion.concat(autoCompleteSuggestions.filter((e,index) => index > Number(count)*25 && index < (Number(count)+1)*25));
                    setfilterSuggestions(suggestion)
                }
            }
		},
		useWindow: false,
		threshold: 150,
		deps: [sliderContRef]
	});

    const filterAutocompleteSuggestions = value => {
        if(value.trim()){
            let filteredSuggestions = autoCompleteSuggestions.filter((e) => e.value.toLowerCase().includes(value.toLowerCase()));
            filteredSuggestions = value ? autoCompleteSuggestions.filter(e => e.value.toLowerCase() != value.toLowerCase()) : filteredSuggestions;
            setfilterSuggestions(filteredSuggestions);
        }else{
            setfilterSuggestions(autoCompleteSuggestions);
        }
    }
    

    /*  */
    const onInputChange = (e) => {

        const { persist, value } = e.target;

        persist && persist();
        setInputValue(value);

        filterAutocompleteSuggestions(value);
    }
    
    const userCustomValueClick = async () => {
        onSelect({
            value: inputValue,
            key: inputValue,
            type: "customValue"
        }); 
        historyHandler.closeCurrent();
    }

    const handleOnSliderHidden = () => {
        filterAutocompleteSuggestions('');
        // setInputValue("");
        toggleSlider(!slider); 
    }

    const ItemResult = withRipple( props => {

        const { item, searchText, autoSuggestionItemOnClick } = props;
    
        const highlighttext = item => {
            return getHighlightString({
                searchKey: searchText,
                searchResult: item.value,
                className: styles["search-highlight"]
            });
        };
    
        return (
            <>
                <div 
                    className={styles["default-auto-suggestion"] + ' ' + props.rippleClass}
                    onClick={e => setTimeout(() => { autoSuggestionItemOnClick(item) }, 300)}
                    {...props.rippleHandler}
                >
                    <div className={styles["left-side"]}>
                        <i
                            className={styles["btn-style"]}
                        ></i>
                    </div>
                    <div
                        className={styles["right-side"]}
                    >
                        <span
                            className={styles["text-style"]}
                            dangerouslySetInnerHTML={{ __html: highlighttext(item) }}
                        ></span>
                    </div>
                    {props.renderRipple()}
                </div>
                <div className={styles["fake-border"]}></div>
            </>
        );
    })

    return (
        <>
            <InputWithMovingLabel 
                {...props}
                onRightIconClick={() => {
                    if(inputValue || !props.fromBrand){
                        if (props.ignoreCross){
                            props.onRightIconClick();
                            toggleSlider(!slider)
                            setInputValue('')
                        }else {
                            if (props?.input?.value){
                                props.onRightIconClick();
                                setInputValue(''); 
                            }else {
                                toggleSlider(!slider)
                            }
                        }
                    }else if(props.fromBrand || props.crossIcon){
                        toggleSlider(!slider)
                    }
                }}
                input={{
                    ...props.input, 
                    onFocus: () => (inputValue && showOutSideFields) ? setInputValue("") : null,
                    onClick: () => props.ignoreCross || !inputValue ? toggleSlider(!slider) :   false
                }}
                rightIconClass={props.ignoreIcon?'':(props?.input?.value && !props.ignoreCross ? "icon-HDRcross" : "icon-Next")}
                errorMessage={props.errorMessage}
                holderClass={`${styles["autosuggest-input"]} ${styles[props.fromBrand ? "hand-pointer":""]}`}
            />
            {
                slider && (
                    <SliderWrapper
                        avoidPortal="true" 
                        header={{
                            heading: sliderHeading,
                            variant: "secondary",
                            leftIcons: [{
                                className: 'icon-HDRback',
                                onClick: (e) => {
                                    window.history.back();
                                    setInputValue('');
                                }
                            }],
                            rightIcons: [],
                            headingClass: styles["heading-label"]
                        }}
                        onHidden={handleOnSliderHidden}
                        updateScrollContRef={ref => {
                            updateRef(ref);
                        }}
                        onScroll={handleScroll}
                    >
                        <SliderHeader 
                            className={`${styles['slider-heading']} ${ styles[props.fromBrand && isScrolled ?'slider-scrolled':'']}`}
                            heading={sliderHeading}
                            leftIcons={[]}
                            rightIcons={[{
                                className: 'icon-HDRcross',
                                onClick: () => {
                                    setInputValue("");
                                }
                            }]}
                            searchBox={true}
                            searchVariant='edit'
                            showOnlySearch={true}
                            inputProps={{
                                placeholder: `Enter ${sliderHeading}`,
                                onChange: onInputChange,
                                isSearchLoading: false,
                                val: inputValue, 
                                onClear: () => {
                                    setInputValue("");
                                    filterAutocompleteSuggestions("")
                                }
                            }} 
                        />
                        {
                            inputValue.trim() && (
                                <>
                                    <div className={styles["user-input-wrapper"]} style={{display: "flex"}} onClick={userCustomValueClick}>
                                        <div className={styles["left-side"]}>
                                            <i className={`${styles["btn-style"]}`}></i>
                                        </div>
                                        <div className={styles["right-side"]}>
                                            <span className={styles["text-style"]}>{inputValue}</span>
                                        </div>
                                    </div>
                                    <div className={styles['fake-border']}></div>
                                </>
                            )
                        }
                        {
                            filterSuggestions.length && (
                                filterSuggestions.map((item,index) => {
                                    return <ItemResult key={item.key} item={item} autoSuggestionItemOnClick={autoSuggestionItemOnClick} searchText={inputValue} />
                                })
                            ) || null
                        }
                    </SliderWrapper>
                ) || null
            }
        </>
    );
}